export default __webpack_public_path__ + "static/media/Legion Necklace.65ff7824.jpg";